module.exports = __webpack_public_path__ + "static/media/icon-tag-moduleF3.994ed51a.png";